import { bookDelete } from "../action";

const deleteBook = (bookId) => {
    return async (dispatch) => {
        await fetch(`http://localhost:9000/books/${bookId}`, {
            method: "DELETE",
        });
        dispatch(bookDelete(bookId));
    };
};

export default deleteBook;
